<template>
<div class="nav-buttons">
  <router-link aria-label="Página anterior" 
    v-if="screenTrack[0] >= 1" :to="'/'+mod.modurl+'/'+ (screenTrack[0]-1)" @click.native.prevent="guardarubicacion() , changeTransitionA()" 
    class="flechas-nav fle-ant animated fadeIn">
    <img src="@/assets/imagenes_compartidas/Flecha_Izquierda_Paginas.png">
  </router-link>
  <router-link aria-label="Página siguiente" 
    v-if="nextPant" :to="'/'+mod.modurl+'/'+ (screenTrack[0]+1)" @click.native.prevent="guardarubicacion() , changeTransitionB()" 
    class="flechas-nav fle-sig animated fadeIn">
    <img src="@/assets/imagenes_compartidas/Flecha_Derecha_Paginas.png">
  </router-link>
</div>
</template>

<script>
import ScormMix from '../js/mixins/scormmixins'
export default {
  props: {
    mod: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    changeTransitionA(num){
      console.log('back'+ this.$store.state.changeTransition)
      this.$store.state.changeTransition = 'content-scroll'
      console.log('new '+ this.$store.state.changeTransition)
      this.$emit('cambioA', 'content-scroll')
    },
    changeTransitionB(num){
      console.log('back'+ this.$store.state.changeTransition)
      this.$store.state.changeTransition = 'content-scrollB'
      console.log('new '+ this.$store.state.changeTransition)
      this.$emit('cambioA', 'content-scrollB')
    }

  },
  computed: {
    nextPant() {
      return this.$store.state.nextPant;
    },
    screenTrack() {
      return this.$store.state.screens;
    },
    currentPage() {
      return Math.floor(this.$route.params.unipage);
    },

  },
  mixins: [ScormMix]
};
</script>

<style lang="scss">
/* Flechas de navegacion

  IMPORTANTE: Estos estilos se encuentran disponibles para todo el proyecto
  con el fin de si se necesita emular el comportamiento de la flecha en alguna pantalla
  sin necesidad de mantener la lógica, se puede copiar y pegar solo el html y los estilos 
  se van a aplicar automáticamente.
 */
 .nav-buttons {
   position: fixed;
   top: 50vh;
   text-align: center;
   font-family: Helveticalstd;
   display: flex;
   flex-flow: column;
   justify-content: center;
   align-items: center;
   width: 100vw;
   z-index: 3;

   p {margin: 0}
   @media (max-width: 600px) {
      top: 50vh;
      z-index: 3;
   }
   
 }
.flechas-nav,
.flechas-nav-blan {
  position: absolute;
  width: 41px;
  height: 41px;
  margin: 20px 0;
  transition: transform 250ms;
  cursor: pointer;
  // background-image: url("../assets/modulo1/flecha-avanzar.png");
  z-index: 3;

  &.fle-ant {
    left: 23px;
    background-position: -43px 0;
    @media (max-width: 600px) {
      left: -3px;
   }
  }

  &.fle-sig {
    right: 23px;
    @media (max-width: 600px) {
      right: -3px;
   }
  } 

  &:hover {
    transform: scale(1.05);    
    filter: drop-shadow(0 5px 5px black);
  }

  /*  En celulares (portrait) las flechas van abajo junto con el botón del menú 
      también se reduce su tamaño
  */
  @media (max-width: 600px) {
      margin: 0 10px;
  
  }
}

// .flechas-nav-blan {
//   // background-image: url("../assets/modulo1/flecha-avanzar-izq.png");
// }
</style>
